import styled from 'styled-components'

import { FlexCentered, FullWidthHeight } from 'components/common/genericStyles'

export const Container = styled.div`
    cursor: pointer;
    ${FullWidthHeight}
    ${FlexCentered}
    position: relative;

    & > .dropdown {
        position: absolute;
        top: 100%;
        right: 25%;
        width: 300px;
    }
`
